import { faArrowRotateRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback } from 'react'

import { useDestroyAllOnboardingTipsMutation } from 'api/onboardingTips/mutations'
import { useUpdateUserCarouselsMutation } from 'api/userCarousels/mutations'
import { updateUserCarouselsQueryClient } from 'api/userCarousels/setters'

import { DropdownMenuItem } from 'components/DropdownMenu'
import { Text } from 'components/Text'

export const ResetOnboarding = () => {
  const { mutate: updateUserCarouselsMutation }
    = useUpdateUserCarouselsMutation()
  const { mutate: destroyAllOnboardingTipsMutation }
    = useDestroyAllOnboardingTipsMutation()

  const handleResetOnboarding = useCallback(() => {
    updateUserCarouselsMutation({ dismissed: 'false', slug: 'onboarding' })
    updateUserCarouselsQueryClient({ dismissed: false, slug: 'onboarding' })
    destroyAllOnboardingTipsMutation()
  }, [updateUserCarouselsMutation, destroyAllOnboardingTipsMutation])

  return (
    <DropdownMenuItem className="h-10">
      <button
        onClick={handleResetOnboarding}
        className="w-full text-left"
        type="button"
      >
        <FontAwesomeIcon icon={faArrowRotateRight} className="mr-2 w-4" />
        <Text>Reset Onboarding</Text>
      </button>
    </DropdownMenuItem>
  )
}
